import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_7eb9ed90 from 'nuxt_plugin_bootstrapvue_7eb9ed90' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_gtm_f7eb2912 from 'nuxt_plugin_gtm_f7eb2912' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_toast_4f3965e0 from 'nuxt_plugin_toast_4f3965e0' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_0c330061 from 'nuxt_plugin_axios_0c330061' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_4b89be09 from 'nuxt_plugin_cookieuniversalnuxt_4b89be09' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_router_79dc5b58 from 'nuxt_plugin_router_79dc5b58' // Source: ../plugins/router.js (mode: 'all')
import nuxt_plugin_metaPixel_39c457a6 from 'nuxt_plugin_metaPixel_39c457a6' // Source: ../plugins/metaPixel.js (mode: 'all')
import nuxt_plugin_tiktokPixel_a1ad9f3c from 'nuxt_plugin_tiktokPixel_a1ad9f3c' // Source: ../plugins/tiktokPixel.js (mode: 'all')
import nuxt_plugin_vueLazyLoad_13d115e9 from 'nuxt_plugin_vueLazyLoad_13d115e9' // Source: ../plugins/vueLazyLoad (mode: 'client')
import nuxt_plugin_plugin_bd12fe46 from 'nuxt_plugin_plugin_bd12fe46' // Source: ./auth/plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"zh-Hant-TW"},"bodyAttrs":{"class":["my-element"]},"title":"錢盈娛樂城","titleTemplate":"%s","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black"},{"hid":"description","name":"description","content":""},{"hid":"keywords","name":"keywords","content":""},{"hid":"copyright","name":"copyright","content":""},{"hid":"author","name":"author","content":""},{"hid":"image","itemprop":"image","content":""},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":""},{"hid":"google-site-verification","property":"google-site-verification","content":""},{"hid":"twitter:title","name":"twitter:title","content":""},{"hid":"twitter:description","name":"twitter:description","content":""},{"hid":"twitter:site","name":"twitter:site","content":""},{"hid":"twitter:card","name":"twitter:card","content":"website"},{"hid":"twitter:image","name":"twitter:image","content":""},{"hid":"twitter:image:alt","name":"twitter:image:alt","content":""},{"hid":"og:title","property":"og:title","content":"","template":(chunk) => `${chunk}`,"vmid":"og:title"},{"hid":"og:description","property":"og:description","content":""},{"hid":"og:keywords","property":"keywords","content":""},{"hid":"og:site_name","property":"og:site_name","content":""},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:image","property":"og:image","content":""},{"hid":"og:image:alt","property":"og:image:alt","content":""},{"hid":"og:locale","property":"og:locale","content":"zh_Hant-TW"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico?v=20230117-3"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ficons\u002Ffavicon-16x16.png?v=20230117-3"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ficons\u002Ffavicon-32x32.png?v=20230117-3"},{"rel":"apple-touch-icon","href":"\u002Ficons\u002Fapple-touch-icon-152x152.png"},{"rel":"mask-icon","href":"\u002Ficons\u002Fsafari-pinned-tab.svg"},{"hid":"canonical","rel":"canonical","href":""},{"hid":"search","rel":"search","href":"\u002Fopensearch.xml","type":"application\u002Fopensearchdescription+xml","title":""}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_7eb9ed90 === 'function') {
    await nuxt_plugin_bootstrapvue_7eb9ed90(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_f7eb2912 === 'function') {
    await nuxt_plugin_gtm_f7eb2912(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_4f3965e0 === 'function') {
    await nuxt_plugin_toast_4f3965e0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0c330061 === 'function') {
    await nuxt_plugin_axios_0c330061(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_4b89be09 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_4b89be09(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (typeof nuxt_plugin_router_79dc5b58 === 'function') {
    await nuxt_plugin_router_79dc5b58(app.context, inject)
  }

  if (typeof nuxt_plugin_metaPixel_39c457a6 === 'function') {
    await nuxt_plugin_metaPixel_39c457a6(app.context, inject)
  }

  if (typeof nuxt_plugin_tiktokPixel_a1ad9f3c === 'function') {
    await nuxt_plugin_tiktokPixel_a1ad9f3c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueLazyLoad_13d115e9 === 'function') {
    await nuxt_plugin_vueLazyLoad_13d115e9(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_bd12fe46 === 'function') {
    await nuxt_plugin_plugin_bd12fe46(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
